import * as R from 'ramda';
import {
  addAddressBookContact$,
  deleteAddressBookContact$,
  getAddressBookContacts$,
} from "../services/users";
import {networkError} from "./ui";

export const CLEAR_ADDRESS_BOOK = 'CLEAR_ADDRESS_BOOK';
export const clearAddressBookCache = () => ({ type: CLEAR_ADDRESS_BOOK, payload: {} });
export const API_GET_ADDRESS_BOOK_USERS_DONE = 'API_GET_ADDRESS_BOOK_USERS_DONE';
export const getAddressBookUsersDone = (results) => ({ type: API_GET_ADDRESS_BOOK_USERS_DONE, payload: results});

export const getAddressBookUsers = ({ userId } = {}) => async (dispatch, getState) => {
  try {
    dispatch(clearAddressBookCache());
    let soFar = 0;
    let theSize = 0;
    let nextOffset;
    do {
      let { response, status: response_status } = await getAddressBookContacts$({ userId, offset: nextOffset }).toPromise();
      if (response_status === 204) {
        dispatch(clearAddressBookCache());
        return;
      }
      if (response === null) return;
      const { results, size } = response;
      theSize = size;
      soFar += results.length;
      if (results.length > 0) {
        dispatch(getAddressBookUsersDone(results));
        nextOffset = R.last(results).contactuserid;
      }
    } while (soFar < theSize);
  } catch (error) {
    dispatch(networkError({...error, number: '10001-'+error.status}));
  }
};

export const addUserToAddressBook = (userId, contactId, callback) => async (dispatch, getState) => {
  try {
    let { response, status } = await addAddressBookContact$({ userId, contactId }).toPromise();
    dispatch(getAddressBookUsers({ userId }));
    callback && callback();
  } catch (error) {
    dispatch(networkError({...error, number: '10002-'+error.status}));
  }
};

export const removeUserFromAddressBook = (userId, contactId, callback) => async (dispatch, getState) => {
  try {
    let { response, status } = await deleteAddressBookContact$({ userId, contactId }).toPromise();
    dispatch(getAddressBookUsers({ userId }));
    callback && callback();
  } catch (error) {
    dispatch(networkError({...error, number: '10003-'+error.status}));
  }
};



// WEBPACK FOOTER //
// ./src/actions/addressbook.js